module.exports = __webpack_public_path__ + "static/media/cart.596428b2.svg";